// React and Icons
import React from 'react'
import { MdOutlineAddCircleOutline } from 'react-icons/md'

// Components
import PageHeader from '../../components/Custom/PageHeader/PageHeader'
import LinkButton from '../../components/Custom/Buttons/LinkButton'
import Brands from '../../components/Brand'

// Hooks and Utils
import useUserStore from '../../utils/state/useUserStore'

const Brand = () => {
    const userPermissions = useUserStore((state) => state.user) || []

    return (
        <div>
            <PageHeader>
                <div className='flex gap-2 items-center justify-between w-full'>
                    <div className='flex gap-2 items-center font-medium'>
                        <h1 className='text-2xl'>Brands</h1>
                    </div>
                    {userPermissions.includes('brand:create') ? (
                        <LinkButton
                            icon={<MdOutlineAddCircleOutline className='text-xl' />}
                            to={'/brand/add'}
                            label={'Add Brand'}
                        />
                    ) : null}
                </div>
            </PageHeader>
            <Brands userPermissions={userPermissions} />
        </div>
    )
}

export default Brand